// extracted by mini-css-extract-plugin
module.exports = {"amount":"amount[Frida]1JCyXk18","processTitle":"processTitle[Frida]aQQoudhz","firstColumn":"firstColumn[Frida]1vxzgK3i","saveButton":"saveButton[Frida]EHbRBA4C"};